"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_NOTIFICATIONS = void 0;
/**
 * @internal Intended for internal use - use it on your own risk
 */
exports.DEFAULT_NOTIFICATIONS = {};
//# sourceMappingURL=model.js.map